import { createSelector } from 'reselect';
import { uniqBy } from 'lodash-es';
import { GlobalState } from 'ha/types/store';
import { City } from 'ha/services/apiV2/types';

import { STATE_NAME } from '../constants';
import { CityListingsCountsMap } from '../types';

import { getSavedSearches } from 'ha/modules/SavedSearches/reducer';

export const getInitialItems = createSelector(
  [getSavedSearches],
  savedSearches => {
    const formatedList = savedSearches.map(savedSearch => ({
      id: savedSearch.cityLocalized,
      label: [savedSearch.cityLocalized, savedSearch.countryLocalized].join(
        ', ',
      ),
    }));

    return uniqBy(formatedList, 'id');
  },
);

export const getListingsCounts = (state: GlobalState): CityListingsCountsMap =>
  state[STATE_NAME].listings.counts;

export const getCities = (state: GlobalState): City[] =>
  state[STATE_NAME].cities.list;
